import React, {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {styled} from "@mui/styles";
import {AppBar, Badge, BottomNavigation, BottomNavigationAction, Drawer, Stack, Typography} from "@mui/material";
import {
    CalendarMonth as CalendarIcon,
    MoreHoriz as MoreIcon,
    Notifications as NotificationsIcon,
    People as PeopleIcon,
} from "@mui/icons-material";
import {MoreMenu} from "../nav";
import {router} from "@atttomyx/react-utils";
import {arrays, strings} from "@atttomyx/shared-utils";
import {PAGE_CALENDAR, PAGE_NOTIFICATIONS, PAGE_PEOPLE, PAGES_MAIN, PAGES_MORE,} from "../../constants";
import "./footer.css";

const ActiveCalendarIcon = styled(CalendarIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveCalendarIcon = styled(CalendarIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const ActiveMoreIcon = styled(MoreIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveMoreIcon = styled(MoreIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const ActiveNotificationsIcon = styled(NotificationsIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveNotificationsIcon = styled(NotificationsIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const ActivePeopleIcon = styled(PeopleIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactivePeopleIcon = styled(PeopleIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const PAGE_MORE = "more";
const PAGE_OTHER = "other";

const NavButton = (props) => {
    const { label, active, icon, onClick } = props;

    return (
        <Stack direction="column" onClick={onClick} className="nav-button">
            {icon}
            <Typography variant="caption" color={active ? "primary" : "text.secondary"}>
                {label}
            </Typography>
        </Stack>
    )
};

const Footer = (props) => {
    const {dimensions, history, numNotifications, onLogout} = props;
    const [showMore, setShowMore] = useState(false);

    useEffect(() => {
        dimensions.onResize();
    }, []);

    const path = strings.sanitizeStr(router.getCurrentPage(history));
    let page = PAGE_OTHER;

    if (arrays.contains(PAGES_MAIN, path)) {
        page = path;

    } else if (arrays.contains(PAGES_MORE, path)) {
        page = PAGE_MORE;
    }

    const renderBottom = () => {
        return (
            <AppBar className="bottom-nav" position="fixed" color="default">
                <BottomNavigation
                    value={page}
                    showLabels={true}
                >
                    <BottomNavigationAction
                        value={PAGE_NOTIFICATIONS}
                        label="Notifications"
                        icon={
                            <Badge
                                color="error"
                                badgeContent={numNotifications}
                                invisible={numNotifications === 0}>
                                <NotificationsIcon/>
                            </Badge>}
                        onClick={() => router.redirectTo(history, PAGE_NOTIFICATIONS)}
                    />
                    <BottomNavigationAction
                        value={PAGE_CALENDAR}
                        label="Calendar"
                        icon={<CalendarIcon/>}
                        onClick={() => router.redirectTo(history, PAGE_CALENDAR)}
                    />
                    <BottomNavigationAction
                        value={PAGE_PEOPLE}
                        label="People"
                        icon={<PeopleIcon/>}
                        onClick={() => router.redirectTo(history, PAGE_PEOPLE)}
                    />
                    <BottomNavigationAction
                        value={PAGE_MORE}
                        label="More"
                        icon={<MoreIcon/>}
                        component="div"
                        onClick={() => setShowMore(true)}
                    />
                </BottomNavigation>
            </AppBar>
        )
    };

    const renderLeft = () => {
        return (
            <Drawer
                variant="permanent"
                anchor="left"
                open={false}
                className="left-nav"
            >
                <div className="nav-buttons">
                    <NavButton
                        label="Notifications"
                        active={page === PAGE_NOTIFICATIONS}
                        icon={
                            <Badge
                                color="error"
                                badgeContent={numNotifications}
                                invisible={numNotifications === 0}
                            >
                                {page === PAGE_NOTIFICATIONS ? <ActiveNotificationsIcon/> : <InactiveNotificationsIcon/>}
                            </Badge>}
                        onClick={() => router.redirectTo(history, PAGE_NOTIFICATIONS)}
                    />
                    <NavButton
                        label="Calendar"
                        active={page === PAGE_CALENDAR}
                        icon={page === PAGE_CALENDAR ? <ActiveCalendarIcon/> : <InactiveCalendarIcon/>}
                        onClick={() => router.redirectTo(history, PAGE_CALENDAR)}
                    />
                    <NavButton
                        label="People"
                        active={page === PAGE_PEOPLE}
                        icon={page === PAGE_PEOPLE ? <ActivePeopleIcon/> : <InactivePeopleIcon/>}
                        onClick={() => router.redirectTo(history, PAGE_PEOPLE)}
                    />
                    <NavButton
                        label="More"
                        active={page === PAGE_MORE}
                        icon={page === PAGE_MORE ? <ActiveMoreIcon/> : <InactiveMoreIcon/>}
                        onClick={() => setShowMore(true)}
                    />
                </div>
            </Drawer>
        )
    };

    return <div className="footer">
        {dimensions.landscape && dimensions.short ? renderLeft() : renderBottom()}
        {showMore ?
            <MoreMenu
                onCancel={() => setShowMore(false)}
                onLogout={onLogout}
            /> : null}
    </div>
}

export default withRouter(Footer);
